/***
 * Model used to fetch and update the user's privacy.
 */
import Backbone from 'backbone';

var Visibility = {
    PUBLIC: 'public',
    PRIVATE: 'private',
    FOLLOWING: 'following',
    GROUPS: 'groups'
};

var SocialProfilePrivacy = Backbone.Model.extend({
    backend: 'gcapi',

    urlRoot: '/userprofile-service/socialProfile/privacy/',

    idAttribute: 'displayName',

    defaults: {
        activityVisibility: 'private',
        profileVisibility: 'private',
        badgeVisibility: 'private'
    },

    url: function() {
        return this.urlRoot + this.get(this.idAttribute); // override to not use encodeURIComponent() due to displayNames with special characters
    }
});

SocialProfilePrivacy.Visibility = Visibility;
export default SocialProfilePrivacy;
